<template>
  <div class="pages-editInfo">
    <div class="user-img">
      <img class="cover" :src="avatar" alt="" />
      <div class="upload">
        重新上传
        <input class="upload-abs" type="file" @change="uploadFile" />
      </div>
    </div>
    <div class="editInfo-line" style="margin-top: 25px">
      <div class="title">修改昵称:</div>
      <el-input
        v-model="nick_name"
        placeholder="请输入内容"
        style="width: 306px"
      ></el-input>
    </div>
    <div class="editInfo-line">
      <div class="title">修改手机号:</div>
      <el-input
        v-model="user_name"
        placeholder="请输入内容"
        style="width: 306px"
      ></el-input>
      <div class="tips">*修改手机号待校级管理员审核通过后生效</div>
    </div>
    <div class="editInfo-line" style="margin-top: 27px">
      <div class="title">修改密码:</div>
      <el-input
        v-model="password"
        placeholder="请输入内容"
        style="width: 306px"
        show-password
      ></el-input>
    </div>
    <div class="submit" @click="submit">提交修改</div>
  </div>
</template>

<script>
import { upload, userSave } from '@/api/api.js'
export default {
  name: 'EditInfo',
  data: () => ({
    userInfo: {},
    coverFile: {},
    avatar: '',
    nick_name: '',
    user_name: '',
    password: '',
  }),
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('yey-user'))
    this.userInfo = userInfo
    this.avatar = userInfo.avatar
    this.nick_name = userInfo.nick_name
    this.user_name = userInfo.user_name
  },
  methods: {
    uploadFile(e) {
      console.log('file', e.target.files)
      let file = e.target.files[0]
      var _URL = window.URL || window.webkitURL
      this.coverFile = {
        type: 'image',
        url: _URL.createObjectURL(file),
        file: file,
        name: file.name,
      }
      this.avatar = this.coverFile.url
    },
    async submit() {
      if (!this.nick_name) {
        this.$message.error('请先填写名称!')
        return
      }
      let reg = /^1[3456789]\d{9}$/
      // if (!reg.test(this.user_name)) {
      //   this.$message.error('请填写正确手机号!')
      //   return
      // }
      let avatar = this.avatar
      if (this.coverFile.file) {
        let formData = new FormData()
        formData.append('file', this.coverFile.file)
        let fileRes = await upload(formData)
        console.log('fileRes', fileRes)
        let ossOrigin = 'https://ms-yey.oss-cn-shanghai.aliyuncs.com/'
        avatar = `${ossOrigin}${fileRes.data.data.url}`
      }
      console.log('avatar', avatar)
      let data = {
        role: 'teacher',
        id: this.userInfo.id,
        nick_name: this.nick_name,
      }

      console.log('data', data)
      // userSave(data).then((res) => {
      //   console.log('userSave', res)
      //   let userInfo = JSON.parse(localStorage.getItem('yey-user'))

      //   userInfo.nick_name = this.nick_name
      //   localStorage.setItem('yey-user', JSON.stringify(userInfo))
      //   this.$message({
      //     type: 'success',
      //     message: '修改成功!',
      //   })
      //   setTimeout(() => {
      //     this.$router.back()
      //   }, 500)
      // })
    },
  },
}
</script>

<style lang="less" scoped>
.pages-editInfo {
  padding-left: 80px;
  .user-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 426px;
    padding-top: 60px;
    .cover {
      width: 112px;
      height: 112px;
      border-radius: 56px;
      background-color: #ccc;
    }
    .upload {
      position: relative;
      width: 98px;
      height: 32px;
      margin-top: 10px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #27b2fe;
      line-height: 32px;
      text-align: center;
      background: #ffffff;
      border-radius: 16px;
      border: 1px solid #27b2fe;
      cursor: pointer;
      .upload-abs {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        opacity: 0;
      }
    }
  }
  .editInfo-line {
    position: relative;
    display: flex;
    align-items: center;
    height: 70px;
    .title {
      width: 110px;
      margin-right: 12px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4d4d4d;
      line-height: 25px;
      text-align: right;
    }
    .tips {
      position: absolute;
      top: 63px;
      left: 122px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
  }
  .submit {
    width: 140px;
    height: 40px;
    margin: 25px 143px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #27b2fe;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
